import React from 'react'
import { Card, Icon, Label } from 'semantic-ui-react';
import Labels from '../../../../../common/Labels';
import EllipsisTooltip from '../../../../../common/EllipsisTooltip';
import ActivityUserInfo from './../ActivityUserInfo';
import { Grid } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
class InitaitveCard extends React.Component {

    async goToCommunity(id, data) {
        await dispatch.home.redirectFromEventStream(true);
        let pLoad = {
            id: id,
            data: data,
            accountId: this.props.selectedAccount._id
        }


        await dispatch.organizationUnit.isSuborgAvailable(pLoad);
    }

    render() {
        const { data, selectedAccount, selectedOrganisation } = this.props;
        return (
            <div className="StreamActivity" >
                {data.from ?
                    <ActivityUserInfo
                        user={data.from}
                        date={data.createdAt}
                        subCategory={data.subCategory}
                        data={data}
                        selectedAccount={selectedAccount}
                        selectedOrganisation={selectedOrganisation}

                    /> : ''}
                <div className="ActivityStreamContent" >
                    <div className="streamCard"
                        onClick={() => this.goToCommunity(data.entityId, data.entityData)}
                    >
                        {!(data.entityData && data.entityData.type && data.entityData.type === 'replaceUser') ?<div className="imageBlock">
                            <Card className=" mar_10 " style={{ width: "180px", boxShadow: "none", border: "1px solid #F0F4F6" }}>
                                <Card.Header className="pad_5"  >
                                    <EllipsisTooltip name={data.entityData.name} />
                                </Card.Header>
                                <Card.Content extra >
                                    <Icon name="sitemap" />
                                    <Label circular color="blue" key="color" className="cardLabel" style={{ margin: "0 5px " }}>
                                        {data.entityData.subOrganizations ? data.entityData.subOrganizations.length : 0}
                                    </Label>
                                    Sub-Team
                                </Card.Content>
                                <Card.Content extra>
                                    <Icon name="group" />
                                    <Label circular color="blue" key="color" style={{ margin: "0 5px " }}>
                                        {data.entityData.members ? data.entityData.members.length : 0}
                                    </Label>
                                    Users
                                </Card.Content>
                            </Card>
                        </div>:""}
                        <div className="contentBlock">
                            <Grid columns='equal'>

                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels
                                            name="Description"
                                            text={<EllipsisTooltip name={data.message ? data.message : 'No description added.'}
                                                line={6}
                                                position="right center"
                                                ReadMore={true}
                                                htmlView={true}
                                                stripHtml={true}
                                            />} />
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InitaitveCard;